<div class="content">
    <div class="content">
     <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 common_title">
          <h2>
            ADD - ANIMAL GENERAL DETAIL
            </h2>
          <!--<p>Create animal general detail</p>-->
          <a (click)="backnavigate()"  class="back_to"><i class="fa fa-chevron-left" aria-hidden="true"></i>
           Back
          </a>
          </div>
      </div>
      <br>
       <form class="row">

 
 <div class="col-lg-4 col-md-6 col-sm-6">
  <div class="form-group">
    <label for="Species Name" >Species Name</label>
    <input type="text" name="Speciesname" id="Speciesname"  readonly="readonly"  value="" class="form-control species">
    </div>
 </div>
 <div class="col-lg-4 col-md-6 col-sm-6">
  <div class="form-group">
    <label for="Species Name" >Breed Name</label>
    <input type="text" name="BreedName" id="BreedName" readonly="readonly"  value="" class="form-control breeds">
    </div>
 </div>
          <!-- <div class="col-lg-4 col-md-6 col-sm-6">
            <div class="form-group">
            <label for="Species Name">Species Name</label>
            <select id="Speciesname" class="selectpicker form-control" (change)="breedselectbyspecies($event)">
              <option selected disabled>Select species</option>
              <option *ngFor='let specieslist of speciesloaddata' [value]="specieslist.id">{{specieslist.name}}</option>
            </select>
            </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="form-group">
                <label for="Breed Name">Breed Name</label>
                <select id="BreedName" class="selectpicker form-control">
                  <option selected disabled>Select Breeds</option>
                  <option *ngFor='let breedname of getspeciesvalue' [value]="breedname.id">{{breedname.name}}</option>
                </select>
                </div>
                </div>-->
       <div class="col-lg-4 col-md-6 col-sm-6 dropdowntop">
        <div class="form-group">
            <label>Gender</label>
            <select id="gender" class="selectpicker form-control">
              <option selected disabled>Select Gender</option>
              <option>Male</option>
              <option>Female</option>
            </select>
            </div>
       </div>
       <div class="col-lg-4 col-md-6 col-sm-6">
        <div class="form-group">
          <label for="Species Name" >Age</label>
          <input type="text" name="Age" id="Age"  readonly="readonly" value="" class="form-control">
          </div>
       </div>
       <div class="col-lg-4 col-md-6 col-sm-6">
        <div class="form-group">
          <label for="Species Name" >Weight</label>
          <input type="text" name="Weight" id="Weight" readonly="readonly"  value="" class="form-control">
          </div>
       </div>
       <div class="col-lg-4 col-md-6 col-sm-6">
        <div class="form-group">
          <label for="Species Name" >Date Of Birth</label>
          <input type="date" name="birthdate" id="birthdate"   readonly="readonly"  value="" class="form-control">
          </div>
       </div>
       <div class="col-lg-4 col-md-6 col-sm-6">
        <div class="form-group">
          <label for="Species Name" >Date Of Transfer</label>
          <input type="date" name="transferdate" id="transferdate"  value="" class="form-control">
          </div>
       </div>
       <div class="col-lg-4 col-md-6 col-sm-6">
        <div class="form-group">
          <label for="Species Name" >Date Of Purchase</label>
          <input type="date" name="purchasedate" id="purchasedate"  value="" class="form-control">
          </div>
       </div>
      
       <div class="col-lg-4 col-md-6 col-sm-6">
        <div class="form-group">
          <label for="Species Name" > Date Of Deletion</label>
          <input type="date" name="deletiondate" id="deletiondate"  value="" class="form-control">
          </div>
        </div>
       <div class="col-lg-12 col-md-12 col-sm-12 text-center">
        <button type="submit" class="btn btn-fill btn-primary mb-3"  (click)="AnimalGeneral()">Submit<div class="ripple-container"></div></button>
        <button  (click)="backnavigate()" class="btn btn-fill btn-default">Cancel<div class="ripple-container"></div></button>
        </div>
       </form>
     </div>
   </div>
  </div>
  
  